import { TwitchEmbedPlayer } from "../components/twitch/types";

export const safeMediaPlay = (
  media: HTMLVideoElement | HTMLAudioElement | TwitchEmbedPlayer,
): {
  play: () => void;
} => {
  return {
    play: async () => {
      try {
        await media.play();
      } catch (error) {
        console.warn("error trying to play media", error);
      }
    },
  };
};
